document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.locations').forEach(el => {
    const tabsInstance = new Tabs({
      scope: el,
      tabs: el.querySelectorAll('.locations__tab'),
      contents: el.querySelectorAll('.locations__tabs-content-item'),
      tabActiveClass: 'locations__tab--active',
      contentActiveClass: 'locations__tabs-content-item--active',
      activateFirst: true
    });

    // Mobile dropdown
    const select = el.querySelector('.locations__select');

    if (select) {
      select.addEventListener('change', e => {
        tabsInstance.activateTab(e.target.selectedIndex);
      });
    }
  });
});